import "./internal.js";
import $ from 'jquery';

import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import tuitionCalculator from "./lib/tuition-calc.js";

document.addEventListener("DOMContentLoaded", function () {
	// console.log("DOM Content Loaded");
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();
	// tuitionCalculator();

	$(function () {
		tuitionCalculator();
	});
});
